var agp = agp || {};

agp.nemid = agp.nemid || {

    login: {

        initCodefileLogin: function () {
            function onNemIDCodeFileMessage(e) {
                var event = e || event;
                var iframeOrigin = $("#codefile_iframe").data("origin");
                var url = $("#codefile_iframe").data("url");
                if (iframeOrigin !== event.origin) {
                    return;
                }
                var win = document.getElementById("codefile_iframe").contentWindow, postMessage = {}, message;
                message = JSON.parse(event.data);

                if (message.command === "SendParameters") {
                    var htmlParameters = document.getElementById("codefile_parameters").innerHTML;

                    postMessage.command = "parameters";
                    postMessage.content = htmlParameters;

                    win.postMessage(JSON.stringify(postMessage), $("#codefile_iframe").data("origin"));
                }

                var returnUrl = $("#codefile_iframe").data("returnurl");
                if (message.command === "changeResponseAndSubmit") {
                    if (message.content === 'Q0FOMDAx' || message.content === 'Q0FOMDAy' || message.content === 'Q0FOMDAz') {
                        document.location.reload();
                    }

                    agp.Util.globalLoader.start();
                    $.ajax({
                        method: "POST",
                        url: url,
                        data: JSON.stringify({ signature: message.content, returnUrl: returnUrl, device: navigator.appVersion, browser: bowser.name + ' (' + bowser.version + ') ' }),
                        contentType: "application/json"
                    })
                        .done(function (result) {
                            if (result === "OK") {

                                //Track NemId nÃ¸glefil login
                                agp.track.loginMedNogleKort();

                                redirectOrReload(returnUrl);
                                return;
                            }

                            agp.Util.globalLoader.stop();

                            $("#codefile_iframe").parent().html(result);

                            Events.NemIdLoginLoggedIn.trigger(result);
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {

                            agp.Util.globalLoader.stop();

                            Events.NemIdLoginError.trigger(errorThrown);
                        });
                }
                if (message.command === "logonCancel") {
                    document.location.replace(".");
                }
                if (message.command === "logonError") {
                    document.signedForm.result.value = message.content;
                    document.signedForm.submit();
                }
            }

            function redirectOrReload(returnUrl) {
                var doRedirectOrReload = function () {

                    document.cookie = "gtm_is_logged_in=1; path=/";

                    if (returnUrl != null && returnUrl != "") {
                        if (returnUrl.toLowerCase().indexOf("/login") == 0)
                            returnUrl = "/";
                        window.location.href = returnUrl;
                    } else {
                        window.location.reload();
                    }
                };

                if (agp && agp.Util && agp.Util.Track && agp.Util.Track.event) {
                    agp.Util.Track.event({
                        'event data': {
                            'category': 'Login',
                            'action': 'Login',
                            'label': returnUrl || window.location.href
                        }
                    }, doRedirectOrReload);
                } else {
                    doRedirectOrReload();
                }
            }

            window.addEventListener ? window.addEventListener("message", onNemIDCodeFileMessage) : window.attachEvent("onmessage", onNemIDCodeFileMessage);
            if (window.addEventListener) {
                window.addEventListener("message", onNemIDCodeFileMessage);
            } else if (window.attachEvent) {
                window.attachEvent("onmessage", onNemIDCodeFileMessage);
            }

        },

        initLogin: function () {

            function onNemIDMessage(e) {
                var event = e || event;

                var origin = $("#nemid__iframe").data("origin");
                var url = $("#nemid__iframe").data("url");

                var win = document.getElementById("nemid__iframe").contentWindow, postMessage = {}, message;
                
                if (event.origin !== origin) {
                    //Events.NemIdDocumentLoginError.trigger("Received message from unexpected origin : " + event.origin);
                    //window.alert("Received message from unexpected origin : " + event.origin);
                    return;
                }

                message = JSON.parse(event.data);

                if (message.command === "SendParameters") {
                    var htmlParameters = document.getElementById("nemid__parameters").innerHTML;

                    postMessage.command = "parameters";
                    postMessage.content = htmlParameters;

                    win.postMessage(JSON.stringify(postMessage), origin);
                }

                var returnUrl = $("#nemid__iframe").data("returnurl");
                if (message.command === "changeResponseAndSubmit") {
                    if (message.content === 'Q0FOMDAx' || message.content === 'Q0FOMDAy' || message.content === 'Q0FOMDAz') {
                        document.location.reload();
                    }

                    agp.Util.globalLoader.start();
                    $.ajax({
                        method: "POST",
                        url: url,
                        data: JSON.stringify({ signature: message.content, returnUrl: returnUrl, device: navigator.appVersion, browser: bowser.name + ' (' + bowser.version + ') ' }),
                        contentType: "application/json"
                    })
                        .done(function (result) {
                            if (result === "OK") {

                                //Track NemId nÃ¸glefil login
                                agp.track.loginMedNogleKort();

                                redirectOrReload(returnUrl);
                                return;
                            }

                            agp.Util.globalLoader.stop();

                            $("#nemid__iframe").parent().html(result);

                            Events.NemIdLoginLoggedIn.trigger(result);
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {

                            agp.Util.globalLoader.stop();

                            Events.NemIdLoginError.trigger(errorThrown);
                        });
                }
            }

            function redirectOrReload(returnUrl) {
                var doRedirectOrReload = function () {

                    document.cookie = "gtm_is_logged_in=1; path=/";

                    if (returnUrl != null && returnUrl != "") {
                        if (returnUrl.toLowerCase().indexOf("/login") == 0)
                            returnUrl = "/";
                        window.location.href = returnUrl;
                    } else {
                        window.location.reload();
                    }
                };

                if (agp && agp.Util && agp.Util.Track && agp.Util.Track.event) {
                    agp.Util.Track.event({
                        'event data': {
                            'category': 'Login',
                            'action': 'Login',
                            'label': returnUrl || window.location.href
                        }
                    }, doRedirectOrReload);
                } else {
                    doRedirectOrReload();
                }
            }

            if (window.addEventListener) {
                window.addEventListener("message", onNemIDMessage);
            } else if (window.attachEvent) {
                window.attachEvent("onmessage", onNemIDMessage);
            }
        }
    },
    signing: {
        initCodefile: function () {
            function onNemIdCodefileSigningMessage(e) {

                var isSigningFrame = $("#codefile_iframe").data("signing");

                if (!isSigningFrame)
                    return;

                var iframeOrigin = $("#codefile_iframe").data("origin");
                var url = $("#codefile_iframe").data("signurl");

                var event = e || event;
                if (iframeOrigin !== event.origin) {
                    return;
                }

                var win = document.getElementById("codefile_iframe").contentWindow, postMessage = {}, message;
                message = JSON.parse(event.data);

                if (event.origin !== iframeOrigin) {
                    //Events.NemIdDocumentSignError.trigger();
                    //window.alert("Received message from unexpected origin : " + event.origin);
                    return;
                }

                if (message.command === "SendParameters") {

                    var htmlParameters = document.getElementById("nemid_signing_parameters").innerHTML;

                    postMessage.command = "parameters";
                    postMessage.content = htmlParameters;

                    win.postMessage(JSON.stringify(postMessage), iframeOrigin);
                }

                if (message.command === "changeResponseAndSubmit") {
                    if (message.content === 'Q0FOMDAx' || message.content === 'Q0FOMDAy' || message.content === 'Q0FOMDAz') {
                        Events.NemIdDocumentSignCancelled.trigger();
                    }

                    agp.Util.globalLoader.start();
                    $.ajax({
                        method: "POST",
                        url: url,
                        data: JSON.stringify({ signature: message.content }),
                        contentType: "application/json"
                    })
                        .done(function (result) {
                            if (result == "Signed")
                                Events.NemIdDocumentSigned.trigger();
                            if (result == "Cancelled")
                                Events.NemIdDocumentSignCancelled.trigger();
                            if (result.indexOf("Error") >= 0) {
                                Events.NemIdDocumentSignError.trigger();
                            }
                            if (result.indexOf("YouAreNotTheLoggenInUser") >= 0) {
                                Events.NemIdDocumentSignNotTheSameUser.trigger();
                            }
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            Events.NemIdDocumentLoginError.trigger(errorThrown);
                        })
                        .always(function () {
                            agp.Util.globalLoader.stop();
                        });
                }
            }

            if (window.addEventListener) {
                window.addEventListener("message", onNemIdCodefileSigningMessage);
            } else if (window.attachEvent) {
                window.attachEvent("onmessage", onNemIdCodefileSigningMessage);
            }
        },

        init: function () {
            function onNemIdSigningMessage(e) {

                var isSigningFrame = $("#nemid_iframe").data("signing");

                if (!isSigningFrame)
                    return; 

                var origin = $("#nemid_iframe").data("origin"); 
                var url = $("#nemid_iframe").data("signurl");

                var event = e || event;

                var win = document.getElementById("nemid_iframe").contentWindow, postMessage = {}, message;                

                if (event.origin !== origin) { 
                    //Events.NemIdDocumentSignError.trigger();
                    //window.alert("Received message from unexpected origin : " + event.origin);
                    return;
                }

                message = JSON.parse(event.data);

                if (message.command === "SendParameters") {

                    var htmlParameters = document.getElementById("nemid_signing_parameters").innerHTML;

                    postMessage.command = "parameters";
                    postMessage.content = htmlParameters;

                    win.postMessage(JSON.stringify(postMessage), origin);
                }

                if (message.command === "changeResponseAndSubmit") {
                    if (message.content === 'Q0FOMDAx' || message.content === 'Q0FOMDAy' || message.content === 'Q0FOMDAz') {
                        Events.NemIdDocumentSignCancelled.trigger();
                    }

                    agp.Util.globalLoader.start();
                    $.ajax({
                        method: "POST",
                        url: url,
                        data: JSON.stringify({ signature: message.content }),
                        contentType: "application/json"
                    })
                        .done(function (result) {
                            if (result == "Signed")
                                Events.NemIdDocumentSigned.trigger();
                            if (result == "Cancelled")
                                Events.NemIdDocumentSignCancelled.trigger();
                            if (result.indexOf("Error") >= 0) {
                                Events.NemIdDocumentSignError.trigger();
                            }
                            if (result.indexOf("YouAreNotTheLoggenInUser") >= 0) {
                                Events.NemIdDocumentSignNotTheSameUser.trigger();
                            }
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            Events.NemIdDocumentLoginError.trigger(errorThrown);
                        })
                        .always(function () {
                            agp.Util.globalLoader.stop();
                        });
                }
            }

            if (window.addEventListener) {
                window.addEventListener("message", onNemIdSigningMessage);
            } else if (window.attachEvent) {
                window.attachEvent("onmessage", onNemIdSigningMessage);
            }
        }
    }
};